'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactElement, useEffect } from 'react';
import ensureSignedSessionIdClient from '@spa/lib/session/ensureSignedSessionIdClient';
import selectGraphqlPublicHostSettings from '@spa/lib/store/settings/selectors/selectGraphqlPublicHostSettings';
import { useSelector } from 'react-redux';

// Checks whether the browser already holds a fresh session id and, only if it doesn't, mints
// one via a dedicated Apollo call. Mount once near the app root, alongside
// ClientLogContextSyncComponent.
const SessionIdSyncComponent = () => {
  const $ = _c(4);
  const {
    host: apolloPublicHost,
    header: apolloPublicHeader
  } = useSelector(selectGraphqlPublicHostSettings);
  let t0;
  let t1;
  if ($[0] !== apolloPublicHeader || $[1] !== apolloPublicHost) {
    t0 = () => {
      ensureSignedSessionIdClient(apolloPublicHost, apolloPublicHeader);
    };
    t1 = [apolloPublicHost, apolloPublicHeader];
    $[0] = apolloPublicHeader;
    $[1] = apolloPublicHost;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
};
export default SessionIdSyncComponent;